import { FeatureCollection } from '@turf/helpers';
import axios, { AxiosInstance } from 'axios';
import { event } from 'vue-gtag';

import GoogleAnalyticsApi, { GoogleAnalyticsEventCategory } from '@/common/apis/GoogleAnalyticsApi';
import DynamicGeofencesUtils from '@/common/components/controls/dynamic-geofences/DynamicGeofences.utils';
import DynamicGeofencesContourType from '@/common/components/controls/dynamic-geofences/enums/DynamicGeofencesContourType.enum';
import DynamicGeofencesParams from '@/common/components/controls/dynamic-geofences/models/DynamicGeofencesParams.model';
import { MapboxPublicToken } from '@/globals';

export interface IsochroneResponse {
  data: FeatureCollection;
  geofenceId: number;
  layerId: string;
}
enum GAEvent {
  IsochroneApiGetRequest = 'isochrone_api_get_request',
  IsochroneApiGetRequestSuccess = 'isochrone_api_get_request_success',
  IsochroneApiGetRequestError = 'isochrone_api_get_request_error',
}

const BASE_URL = 'https://api.mapbox.com/isochrone/v1/mapbox/';
const CONTOURS_MINUTES = 'contours_minutes';
const CONTOURS_METERS = 'contours_meters';

export default class IsochroneApi {
  private axiosInstance: AxiosInstance;

  constructor() {
    this.axiosInstance = axios.create({
      baseURL: BASE_URL,
    });
  }

  public async getIsochrones(params: DynamicGeofencesParams): Promise<IsochroneResponse> {
    const { profile, contour, coordinates, geofenceId, options } = params;
    const formattedCoordinates = `${coordinates[0]},${coordinates[1]}`;
    const contourType = contour === DynamicGeofencesContourType.Time ? CONTOURS_MINUTES : CONTOURS_METERS;
    const contourFilter = `${contourType}=${options}`;
    const polygonFilter = 'polygons=true';
    const denoiseFilter = 'denoise=1';
    const accessToken = `access_token=${MapboxPublicToken}`;
    const url = `${profile}/${formattedCoordinates}?${contourFilter}&${polygonFilter}&${denoiseFilter}&${accessToken}`;
    GoogleAnalyticsApi.sendEvent(GAEvent.IsochroneApiGetRequest, {
      category: GoogleAnalyticsEventCategory.Isochrone,
      label: GAEvent.IsochroneApiGetRequest,
    });

    try {
      const res = await this.axiosInstance.get(url);
      event(GAEvent.IsochroneApiGetRequestSuccess, {
        category: GoogleAnalyticsEventCategory.Isochrone,
        label: GAEvent.IsochroneApiGetRequestSuccess,
      });

      return {
        data: res?.data,
        geofenceId,
        layerId: DynamicGeofencesUtils.getMapLayerId(geofenceId),
      };
    } catch (error) {
      event(GAEvent.IsochroneApiGetRequestError, {
        category: GoogleAnalyticsEventCategory.Isochrone,
        label: GAEvent.IsochroneApiGetRequestError,
      });
      console.log(error);
      throw error;
    }
  }
}
